import React, { Component } from "react";
import {
    MoneyField,
    MoneyWithCurrencyField,
} from "buenLib/components/MoneyField";
import { Spinner } from "reactstrap";
import "assets/sass/dashboard/deposits/withdraws/WithdrawSummary.scss";
import { AppContext } from "app/state/AppContext";

export class WithdrawSummary extends Component {
    static contextType = AppContext;

    componentDidMount() {
        const { fecthTaxes } = this.context;
        fecthTaxes();
    }

    renderConfirmWithdrawButton() {
        if (this.props.operationInProgress) {
            return <Spinner className="spinner-color" />;
        } else {
            return (
                <button
                    className="cta-button mt-3"
                    onClick={this.props.handleContinue}
                >
                    CONFIRMAR TRANSFERENCIA
                </button>
            );
        }
    }

    render() {
        const form = this.props.withdrawForm;
        const { taxes } = this.context;
        const descriptionTaxes = taxes;

        return (
            <div className="summary">
                <h1>Resumen de la transferencia</h1>
                <div className="receipt-box">
                    <div className="box-header">
                        <div className="user d-block d-sm-none">
                            {form.account().ownerName()}
                        </div>
                        <div className="money">
                            <span className="currency">
                                {form.currency().code()}
                            </span>
                            <span className="price">
                                <MoneyField
                                    value={form.amountField().value()}
                                    currency={form.currency()}
                                    decimalScale={2}
                                />
                            </span>
                        </div>
                    </div>
                    <div className="data">
                        {this.renderBank(form)}
                        {this.renderUniformKey(form)}
                        {this.renderAlias(form)}
                        {this.renderFee(form)}
                        {this.renderDate()}
                        {this.renderAmount(form)}
                        {this.renderTaxes(form)}
                        {this.renderSummaryId(form)}
                    </div>
                    <div className="text-center">
                        {descriptionTaxes.map((e, i) => (
                            <div key={i} className="label-taxes">
                                *{e.description}
                            </div>
                        ))}
                    </div>
                    <div className="text-center">
                        {this.renderConfirmWithdrawButton()}
                    </div>
                </div>
            </div>
        );
    }

    renderBank(form) {
        return this.renderSummaryDataField(form.account().bankName(), "Banco");
    }

    renderUniformKey(form) {
        return this.renderSummaryDataField(
            form.account().uniformKey(),
            "CBU/CVU"
        );
    }

    renderAlias(form) {
        return this.renderSummaryDataField(form.account().alias(), "Alias");
    }

    renderFee(form) {
        const fee = form.fee() || 0;
        if (fee > 0) {
            let moneyField = (
                <MoneyWithCurrencyField
                    value={fee.toString()}
                    currency={form.currency()}
                />
            );
            return this.renderSummaryDataField(moneyField, "Comisión");
        }
    }

    renderDate() {
        return this.renderSummaryDataField(
            new Date().toLocaleDateString("es"),
            "Fecha"
        );
    }

    renderSummaryId(form) {
        return this.renderSummaryDataField(form.withdrawID(), "Comprobante");
    }

    renderAmount(form) {
        return this.renderSummaryDataField(
            form.amountField().displayValue(),
            "Monto a retirar",
            "$"
        );
    }

    renderTaxes(form) {
        if (Number(form.taxesField().displayValue()) === 0) return null

        return this.renderSummaryDataField(
            Number(form.taxesField().displayValue()).toFixed(2),
            "Impuestos*",
            "$"
        );
    }

    renderSummaryDataField(data, label, prefix) {
        if (data) {
            return (
                <div className="data-row">
                    <span className="label">{label}</span>
                    <span className="value">
                        {prefix && prefix}
                        {data}
                    </span>
                </div>
            );
        }
    }
}
